export default __webpack_public_path__ + "static/lysicrates-statue-background-8b9400cfc4cfe0fc32c4c47cfec44838.jpg";